import React from "react";
import aboutImg from "../assets/whychoose.png";

const WhyChooseSection = () => {
  return (
    <>
      <style>{`
        .why-section {
          background: #EFFFE1;
          padding: 100px 20px;
        }

        .why-container {
          max-width: 1100px;
          margin: auto;
          display: flex;
          align-items: center;
          justify-content: space-between;

          gap: 30px; /* ✅ reduced gap */
        }

        /* LEFT */
        .why-left {
          max-width: 520px;
        }

        .why-left h2 {
          font-size: 38px;
          font-weight: 700;
          color: #0F3D2E;
          margin-bottom: 20px;
          line-height: 1.3;
        }

        .why-left p {
          font-size: 16px;
          color: #555;
          line-height: 1.7;
          margin-bottom: 40px;
        }

        /* STATS */
        .stats {
          display: grid;
          grid-template-columns: repeat(2, 1fr);
          gap: 30px 40px;
        }

        .stat {
          display: flex;
          gap: 15px;
          align-items: flex-start;
        }

        .line {
          width: 4px;
          height: 50px;
          background: #7ED957;
          border-radius: 2px;
        }

        .stat h3 {
          font-size: 28px;
          margin: 0;
          color: #0F3D2E;
        }

        .stat p {
          margin: 5px 0 0;
          font-size: 14px;
          color: #666;
        }

        /* RIGHT IMAGE */
        .why-image {
          flex: 1;
          display: flex;
          justify-content: flex-end;
        }

        .why-image img {
          width: 100%;
          max-width: 480px; /* ✅ increased from 420 */
          height: 380px; /* ✅ gives strong presence */
          object-fit: cover;
          border-radius: 20px;
        }

        /* RESPONSIVE */
        @media (max-width: 900px) {
          .why-container {
            flex-direction: column;
            text-align: center;
            gap: 40px;
          }

          .stats {
            grid-template-columns: 1fr;
          }

          .stat {
            justify-content: center;
          }

          .why-image img {
            max-width: 100%;
            height: auto;
          }
        }
      `}</style>

      <section className="why-section">
        <div className="why-container">

          {/* LEFT */}
          <div className="why-left">
            <h2>
              Why Clients Choose Welthan for Success
            </h2>

            <p>
              We’re more than accountants — we’re partners who care about your success.
              With transparent pricing, personalized service, and decades of combined
              experience, we make finance simple and stress-free.
            </p>

            <div className="stats">

              <div className="stat">
                <div className="line"></div>
                <div>
                  <h3>15+</h3>
                  <p>Years of Experience</p>
                </div>
              </div>

              <div className="stat">
                <div className="line"></div>
                <div>
                  <h3>500+</h3>
                  <p>Businesses Served</p>
                </div>
              </div>

              <div className="stat">
                <div className="line"></div>
                <div>
                  <h3>98%</h3>
                  <p>Client Satisfaction</p>
                </div>
              </div>

              <div className="stat">
                <div className="line"></div>
                <div>
                  <h3>$10M+</h3>
                  <p>Saved in Taxes</p>
                </div>
              </div>

            </div>
          </div>

          {/* RIGHT */}
          <div className="why-image">
            <img src={aboutImg} alt="Why Choose Us" />
          </div>

        </div>
      </section>
    </>
  );
};

export default WhyChooseSection;